import { render } from "./LivePrescripiton.vue?vue&type=template&id=08c2c75e&scoped=true"
import script from "./LivePrescripiton.vue?vue&type=script&lang=js"
export * from "./LivePrescripiton.vue?vue&type=script&lang=js"

import "./LivePrescripiton.vue?vue&type=style&index=0&id=08c2c75e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08c2c75e"]])

export default __exports__